import React from 'react';
import { useSwipeable } from 'react-swipeable';

function SwipeableHook(props) {
    const {
        children,
        className,
        style,
        paramsSwipe = {}
    } = props;

    const eventHandlers = useSwipeable(paramsSwipe);
    /*const eventHandlers = useSwipeable({
        onSwipedLeft: () => {console.log("test left");},
        onSwipedRight: () => {console.log("test right");},
        preventDefaultTouchmoveEvent: true,
        trackMouse: true
    });*/
    return (<div {...eventHandlers} style={style} className={className}>{children}</div>);
}

export default SwipeableHook;

